var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-some"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"复制","placement":"top"}},[_c('i',{staticClass:"el-icon-document-copy",style:({ marginLeft: '0.1rem', cursor: 'pointer', color: _vm.color }),on:{"click":function($event){return _vm.copySome(_vm.copyData)}}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0246c2ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonReform/CopySome.vue
// module id = null
// module chunks = 